<app-job-pointe-list [tableData]="data" [searchParams]="requestParams" [tableFilters]="filters" [source]="data.type">
</app-job-pointe-list>
